import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';

const apps = [
    'User Management',
    'Invoice Management',
    'Support Center',
    'Customers',
    'Devs Forum',
    'Subscriptions',
    {
        label: 'Chat',
        children: ['Private Chat', 'Group Chat', 'Drawer Chat'],
    },
];

export function AppsMenu() {
    return (
        <Menu as="div" className="relative inline-block text-left">
            <Menu.Button className="text-sm text-gray-400 hover:text-white">Apps</Menu.Button>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
            >
                <Menu.Items className="absolute left-0 mt-2 w-56 origin-top-left rounded-md bg-white text-black shadow-lg ring-1 ring-black/5 focus:outline-none z-50">
                    <div className="p-2 space-y-1">
                        {apps.map((item, i) =>
                            typeof item === 'string' ? (
                                <Menu.Item key={i}>
                                    {({ active }) => (
                                        <div
                                            className={`cursor-pointer px-4 py-2 text-sm rounded ${active ? 'bg-gray-100' : ''
                                                }`}
                                        >
                                            {item}
                                        </div>
                                    )}
                                </Menu.Item>
                            ) : (
                                <Menu.Item key={i}>
                                    <div className="group relative px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 rounded">
                                        {item.label}
                                        <div className="absolute left-full top-0 mt-0 ml-1 w-44 bg-white border border-gray-200 rounded shadow-lg hidden group-hover:block">
                                            {item.children.map((child, j) => (
                                                <div key={j} className="px-4 py-2 hover:bg-gray-100">
                                                    {child}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </Menu.Item>
                            )
                        )}
                    </div>
                </Menu.Items>
            </Transition>
        </Menu>
    );
}
